import api from "@/api/api-v2-config";

export async function getSalesReport() {
    return await api.get("reports/salesreport");
}

export async function getFinishedGoodReport() {
    return await api.get("reports/finishedgoodsmovementreport");
}

export async function getSemiReport() {
    return await api.get("reports/semifinishedgoodsmovementreport");
}


export async function getRawReport() {
    return await api.get("reports/rawmaterialsmovementreport");
}


export async function CostAnalysis() {
    return await api.get("reports/productioncostanalysisreport")
}



export async function getProductionReport() {
    return await api.get("reports/productionreport")
}

export async function getLeadTimeReport() {
    return await api.get("reports/productionleadtimeanalysisreport")
}

export async function getLeadTimeConversion() {
    return await api.get("reports/leadconversionratereport")
}

export async function getBalanceSheetReportAxios(dateFrom, dateTo) {
//     console.log("date", dateFrom);
// console.log("dates", dateTo);
    return await api.get(`reports/balancesheetreport?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getProfitAndLossReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/profitandloss?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getTrialBalanceReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/trialbalancereport?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getTdsReportAxios(dateFrom, dateTo) {
    return await api.get(`accountreports/gettds?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getVatReturnReportAxios(dateFrom, dateTo) {
    return await api.get(`accountreports/getvatreturn?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getCashBookReportAxios(dateFrom, dateTo) {
    return await api.get(`accountreports/getcashbook?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getPayrollVarianceReportAxios (dateFrom, dateTo) {
    return await api.get(`reports/getpayrollvariancereport?Period1=${dateFrom}&Period2=${dateTo}`)
}

export async function getGeneralLedgerReportAxios (dateFrom, dateTo) {
    return await api.get(`reports/generalledgerreport?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getComplaintResolutionTimeReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/complaintresolutiontimereport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getStaffComplaintHandlingPerformanceAxios(dateFrom, dateTo) {
    return await api.get(`reports/staffcomplaintperformancereport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getCustomerComplaintFrequencyAxios(dateFrom, dateTo) {
    return await api.get(`reports/customercomplaintfrequencyreport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getLeadClientOpportunityCostSummaryAxios(dateFrom, dateTo) {
    return await api.get(`reports/leadclientopportunitysummaryreport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getCustomerTicketVolumeAnalysisAxios(dateFrom, dateTo) {
    return await api.get(`reports/customerticketvolumeanalysischartreport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getSalesSummaryReportAxios(groupBy, dateFrom, dateTo) {
    return await api.get(`reports/salessummaryreport?groupBy=${groupBy}&startDate=${dateFrom}&endDate=${dateTo}`)
}
export async function getSalesValueContributionBySalespersonAxios(dateFrom, dateTo) {
    return await api.get(`/reports/salesvaluecontributionreport?startDate=${dateFrom}&endDate=${dateTo}`)
}
export async function getLeadAgingAnalysisAxios(dateFrom, dateTo) {
    return await api.get(`/reports/leadagingreport?startDate=${dateFrom}&endDate=${dateTo}`)
}
export async function getSalesAnalyticsReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/salesanalyticsreport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getSalesAnalyticsReportByProductAxios(dateFrom, dateTo) {
    return await api.get(`reports/salesanalyticsperproductreport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getSalesAnalyticsReportByClientAxios(dateFrom, dateTo) {
    return await api.get(`reports/salesanalyticsperclientreport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getTicketCategoryReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/ticketcategoryreport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getQuotationPriorityReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/quotationpriorityreport?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getProductionCostAnalysisReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/productioncostanalysisreport?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getProductionReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/productionreport?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getProductionLeadTimeAnalysisReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/productionleadtimeanalysisreport?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getProjectCostAnalysisReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/projectcostanalysis?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getProjectStatusReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/projectstatus?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getInventoryValueAnalysisReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/inventoryvalueanalysis?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function getInventoryQtyAnalysisReportAxios(dateFrom, dateTo, itemId) {
    return await api.get(`reports/inventoryqtyanalysis?dateFrom=${dateFrom}&dateTo=${dateTo}&itemId=${itemId}`)
}

export async function getWarehouseDistributionReportAxios(dateFrom, dateTo) {
    return await api.get(`reports/warehousedistribution?startDate=${dateFrom}&endDate=${dateTo}`)
}

export async function getMonthlySpendingByPlatformAxios(dateFrom, dateTo) {
    return await api.get(`reports/monthlyspendingbyplatform?startDate=${dateFrom}&endDate=${dateTo}`)
}